import axios from 'axios'

const purchaseApi = axios.create({
  baseURL: process.env.REACT_APP_PURCHASE_API
})

export default purchaseApi
